import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  IUserSettingsState,
  loadOrInitUserSettings,
  shouldLoadUserSettings,
} from 'redux/reducers/userSettings';

import { logToAmplitude } from 'helpers/logAmplitudeEvent';
import { ReactComponent as AndroidIcon } from 'icons/android-icon.svg';

import { RootState } from 'redux/rootReducer';
import { saveUserIsInterestedInAndroidApp } from 'redux/reducers/user/updateUsetIsInterestedInAndroidApp';

import { AndroidText, Link } from './styles';

const AndroidInterestText: React.FC<{ isSmallScreen?: boolean }> = ({
  isSmallScreen,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (dispatch(shouldLoadUserSettings())) {
      dispatch(loadOrInitUserSettings());
    }
  }, [dispatch]);

  const onLinkClick = (): void => {
    logToAmplitude('Interested in Android Notifier');
    dispatch(saveUserIsInterestedInAndroidApp(true));
  };

  const userSettings = useSelector(
    (state: RootState): IUserSettingsState => state.userSettings
  );
  const isInterested = userSettings?.data?.userIsInterestedInAndroidApp;

  return (
    <AndroidText>
      Sorry, <AndroidIcon /> Android app is not available yet!
      {isSmallScreen ? <br /> : null}{' '}
      {isInterested ? (
        'Thank you for your interest.'
      ) : (
        <Link onClick={onLinkClick}>Click here to register your interest.</Link>
      )}
    </AndroidText>
  );
};

export default AndroidInterestText;
